export default __webpack_public_path__ + "static-bigflip/media/business-catalogue.aa63c224.png";